module.exports = __webpack_public_path__ + "img/2.2856ff91.jpg";